import React from 'react';
import { Form, Input, Button, Card, message, ConfigProvider } from 'antd';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services';

const ChangePassword = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = React.useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (values) => {
        try {
            setLoading(true);
            const response = await authService.changePassword(
                values.oldPassword,
                values.newPassword,
                values.confirmPassword
            );

            if (response.data.code === 200) {
                message.success('密码修改成功，请重新登录');
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                navigate('/login');
            }
        } catch (error) {
            message.error(error.response?.data?.message || '修改失败');
        } finally {
            setLoading(false);
        }
    };

    return (
        <ConfigProvider theme={{
            token: {
                fontFamily: '仿宋, serif'
            }
        }}>
            <div style={{ maxWidth: 400, margin: '50px auto' }}>
                <Card title="修改密码">
                    <Form form={form} layout="vertical" onFinish={handleSubmit}>
                        <Form.Item
                            label="原密码"
                            name="oldPassword"
                            rules={[{ required: true, message: '请输入原密码' }]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item
                            label="新密码"
                            name="newPassword"
                            rules={[{ required: true, message: '请输入新密码' }]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item
                            label="确认密码"
                            name="confirmPassword"
                            rules={[{ required: true, message: '请确认密码' }]}
                        >
                            <Input.Password />
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit" loading={loading} block>
                                修改
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </div>
        </ConfigProvider>
    );
};

export default ChangePassword;
